import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Firebase only initialises once the web config (apiKey + appId) is present.
export const FIREBASE_READY = Boolean(config.apiKey && config.appId);

let auth = null;
if (FIREBASE_READY) {
  const app = getApps()[0] || initializeApp(config);
  auth = getAuth(app);
}

export { auth };
export const googleProvider = new GoogleAuthProvider();
